import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const accessoryTechRoutes = {
  [ERouteMappingKeys.ACCESSORY_TECH]: {
    id: "accessory-tech",
    path: "/integrations/accessory-tech",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/Accessories").then((p) => ({
          default: p.Accessories,
        })),
      ),
      "internet-solutions": lazy(() =>
        import("pages/Sections/Integrations/InternetSolutions").then((p) => ({
          default: p.InternetSolutions,
        })),
      ),
      "sfp-wizard": lazy(() =>
        import("pages/Sections/Integrations/SfpWizard/SfpWizard").then((p) => ({
          default: p.SfpWizard,
        })),
      ),
      "travel-router": lazy(() =>
        import("pages/Sections/Integrations/TravelRouter/TravelRouter").then(
          (p) => ({ default: p.TravelRouter }),
        ),
      ),
      "air-wire": lazy(() =>
        import("pages/Sections/Integrations/AirWire/AirWire").then((p) => ({
          default: p.AirWire,
        })),
      ),
    },
  },
};
